import { useCallback } from 'react';

import dayjs from 'dayjs';

import {
    type CollectionSalesVolumeArgs,
    type FloorPriceChangesArgs,
    useCollectionSalesVolume,
    useGetFloorpriceHistory,
} from '@pkg/hooks';

type UsePricingDataArgs = FloorPriceChangesArgs &
    CollectionSalesVolumeArgs & {
        days?: number;
    };

export function usePricingData() {
    const getFloorPriceChanges = useGetFloorpriceHistory();
    const getSalesVolume = useCollectionSalesVolume();

    return useCallback(
        async ({ slugs: _slugs, days = 7, chain }: UsePricingDataArgs) => {
            if (!_slugs) return;
            const slugs = _slugs.sort();
            const _chain = chain ? chain : undefined;
            const now = dayjs();
            const fromDate = now.subtract(days, 'day');
            const startDate = fromDate.toISOString().split('T')[0];
            const endDate = now.toISOString().split('T')[0];
            const salesVolumes = await getSalesVolume({
                slugs,
                startDate,
                endDate,
                chain: _chain,
            });

            const floorPriceChanges = await getFloorPriceChanges({
                slugs,
                startDate,
                endDate,
                chain: _chain,
            });

            return { salesVolumes, floorPriceChanges };
        },
        [getFloorPriceChanges, getSalesVolume],
    );
}
